import { defineMessages } from "react-intl";

import { node as cardiovascularDiseases } from "src/modules/ktx/forms/transplantation-screening/medical-history/cardiovascularDiseases";
import { node as chronicLiverFailure } from "src/modules/ktx/forms/transplantation-screening/medical-history/chronic-liver-failure";
import { node as covid } from "src/modules/ktx/forms/transplantation-screening/medical-history/covid";
import { node as haemostaseology } from "src/modules/ktx/forms/transplantation-screening/medical-history/haemostaseology";
import { node as hepatologyDiseases } from "src/modules/ktx/forms/transplantation-screening/medical-history/hepatologyDiseases";
import { node as medicalTreatment } from "src/modules/ktx/forms/transplantation-screening/medical-history/medicalTreatment";
import { node as metabolicDisease } from "src/modules/ktx/forms/transplantation-screening/medical-history/metabolicDisease";
import { node as nephrectomyOrGraftectomy } from "src/modules/ktx/forms/transplantation-screening/medical-history/nephrectomyOrGraftectomy";
import { node as oncologyDisease } from "src/modules/ktx/forms/transplantation-screening/medical-history/oncologyDisease";
import { node as otherDisorders } from "src/modules/ktx/forms/transplantation-screening/medical-history/otherDisorders";
import { node as otherSurgicalIntervention } from "src/modules/ktx/forms/transplantation-screening/medical-history/otherSurgicalIntervention";
import { node as renalAnaemiaHematology } from "src/modules/ktx/forms/transplantation-screening/medical-history/renalAnaemiaHematology";
import { node as risks } from "src/modules/ktx/forms/transplantation-screening/medical-history/risks";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.medical_history",
		defaultMessage: "Anamnézis"
	}
});

export const node: ParentNode = {
	id: "ktx-medical-history",
	value: { type: "wizard", title: messages.title },
	children: [
		cardiovascularDiseases,
		metabolicDisease,
		hepatologyDiseases,
		chronicLiverFailure,
		oncologyDisease,
		renalAnaemiaHematology,
		haemostaseology,
		otherDisorders,
		nephrectomyOrGraftectomy,
		otherSurgicalIntervention,
		covid,
		risks,
		medicalTreatment
	]
};
